import { colors as lightColors } from './colors.light.js';
export const theme = {
    id: 'default',
    name: 'Default',
    colors: {
        light: lightColors,
        dark: lightColors,
    },
};
//# sourceMappingURL=theme.js.map